export const getGroupDescription = (groupName) => {
  groupName = (groupName || '').toLowerCase();
  // console.log("groupName", groupName);
  switch (groupName) {
    case 'material':
      return "quotingTool.featureGroupDescription.material";
    case "room":
      return "quotingTool.featureGroupDescription.room";
    case "edge profile":
    case "edge":
      return "quotingTool.featureGroupDescription.edgeProfile";
    case "cutouts":
      return "quotingTool.featureGroupDescription.cutouts";
    case "faucets":
    case "faucet":
      return "quotingTool.featureGroupDescription.faucet";
    case "sinks":
    case "sink":
      return "quotingTool.featureGroupDescription.sink";
    case "counter top removal":
    case "countertop removal":
      return "quotingTool.featureGroupDescription.countertopRemoval";
    case "counter top disposal":
    case "countertop disposal":
      return "quotingTool.featureGroupDescription.countertopDisposal";
    case "radius":
      return "quotingTool.featureGroupDescription.radius";
    case "plumbing":
      return "quotingTool.featureGroupDescription.plumbing";
    case "backsplash":
      return "quotingTool.featureGroupDescription.backsplash";
    case "sealer":
      return "quotingTool.featureGroupDescription.sealer";
    case "hourly labor":
      return "quotingTool.featureGroupDescription.hourly";
    case "trip charge":
      return "quotingTool.featureGroupDescription.tripCharge";
    case "milling down":
      return "quotingTool.featureGroupDescription.millingDown";
    case "template":
      return "quotingTool.featureGroupDescription.template";
    case "15 year sealer":
      return "quotingTool.featureGroupDescription.15YearsSealer";
    case "10 year sealer":
      return "quotingTool.featureGroupDescription.10YearsSealer";
    case "finishes":
      return "quotingTool.featureGroupDescription.finishes";
    case "flat metal support brackets":
      return "quotingTool.featureGroupDescription.flatMetalSupportBrackets";
    case "bump out":
      return "quotingTool.featureGroupDescription.bumpOut";
    case "inside corner":
      return "quotingTool.featureGroupDescription.insideCorner";
    case "45 degree inside corner":
      return "quotingTool.featureGroupDescription.45DegreeInsideCorner";
    case "arch":
      return "quotingTool.featureGroupDescription.arch";
    case "cooktop type":
      return "quotingTool.featureGroupDescription.cooktopType";
    case "sink type":
      return "quotingTool.featureGroupDescription.sinkType";
    case 'stove type':
      return 'quotingTool.featureGroupDescription.stoveType';
    case 'protection plan':
      return 'quotingTool.featureGroupDescription.protectionPlan';
    default:
      return 'quotingTool.featureGroupDescription.default';
  }
}
